// English strings (source language): Play screen.

const en = {
  title: 'Play',
  intro: 'Choose who you ride with, a mode and a track. Bots match your W/kg, so the race stays close.',
  who: 'Who are you riding with?',
  solo: 'Solo',
  soloHelp: 'Against bots, starts right away.',
  friends: 'With friends',
  friendsHelp: 'Open a room and share its code. Everyone rides live, on their own trainer.',
  haveCode: 'Got a code from a friend?',
  join: 'Join',
  watch: 'Watch',
  watchHelp: 'No trainer needed: follow the room live as a supporter, with TV cameras, the chat and cheers.',
  badCode: 'Enter the 4-letter code.',
  hostStart: 'Create the room',
  hostTip: 'You can still change everything in the room, until you start the race.',
  soloOnly: 'Solo only',
  needsLoop: 'Needs a loop',
  pointToPoint: 'A to B',
  inRoom: (code: string) => `You are in room ${code}.`,
  backToRoom: 'Back to the room',
  openStore: 'Store',
  emptyCollection: 'Nothing to race with yet',
  emptyCollectionHelp: 'Your collection has no mode or no track. Add some from the store, they are free.',
  inventMode: 'Invent a mode',
  drawTrack: 'Draw a track',
  mine: 'yours',
  community: 'community',
  theme: 'Ambience',
  createTheme: 'Create an ambience',
  themeUnlockedAt: (n: number) => `Unlocked at level ${n}`,
  communityItems: 'Community items',
  inventItem: 'Invent an item',
  communityItemsHelp: 'Tick the ones to add to the item boxes for this race (12 at most, including the mode’s own).',
  arcade: 'Arcade',
  inventGame: 'Invent a game',
  arcadeHelp: 'Games where your pedalling is the controller. They can also be played during a workout (Training).',
  mode: 'Mode',
  track: 'Track',
  unlockedAt: (n: number) => `Unlocked at level ${n}`,
  trackStats: (km: string, climb: string, grade: string) => `${km} km per lap · ${climb} m of climbing · max grade ${grade}%`,
  /** The same figures for a road from A to B, ridden once. */
  roadStats: (km: string, climb: string, grade: string) => `${km} km from start to finish · ${climb} m of climbing · max grade ${grade}%`,
  options: 'Options',
  laps: 'Laps',
  bots: 'Bots',
  botLevel: 'Bot level',
  levelReq: (n: number) => `lvl ${n}`,
  elastic: 'Keep the group together',
  elasticHelp: 'Everyone rides together whatever their watts: pushing harder only moves you up the group. Stop pedalling and it goes on without you, until you start again. Your activity keeps the distance your own watts covered.',
  groupPace: (wkg: string, w: number) => `Group pace: ${wkg} W/kg (${w} W)`,
  ghostRecord: (time: string) => `Record to beat: <b>${time}</b>`,
  noGhost: 'No ghost on this track yet: your first run will become the ghost.',
  segmentRecords: 'Your records:',
  yourRace: 'Your race',
  start: 'Start',
  tip: 'Tip: connect your smart trainer or power meter before the start: your watts only come from it.',
  items: 'Items',
  itemsChoose: 'Choose the ones you want',
  itemsPick: 'Untick the ones you do not want in the boxes.',
  itemsKept: (n: number, all: number) => `${n} of ${all} items in the boxes`,
  itemsNone: 'No items in the boxes',
  itemsHelp: 'The further behind you are, the stronger the items: the leader mostly gets bananas and shields.',
};
export default en;
